import React, {useState, useEffect} from 'react';

function slideSystem(slides, lifecycleFunctions) {
	let {done, next} = lifecycleFunctions;

	let [slideIndex, setSlideIndex] = useState(0);

	useEffect(() => {
		setSlideIndex(0);
	}, []);

	if (slideIndex >= slides.length) {
		setSlideIndex(0);
	}
	let CurrentSlide = slides[slideIndex];
	//create as much of the user as possible here
	return <CurrentSlide nextPressed={nextPressed} />;

	function nextPressed(questionareFrag, options) {
		next(questionareFrag, options);
		if (nextSlideExzists()) {
			setSlideIndex(slideIndex + 1);
		} else {
			done();
		}
	}

	function nextSlideExzists() {
		if (slideIndex + 1 < slides.length) {
			return true;
		}
		return false;
	}
}

export default slideSystem;
